// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    logs: `${ROOTS.DASHBOARD}/logs`,
    summary: `${ROOTS.DASHBOARD}/summary`,
    report: `${ROOTS.DASHBOARD}/report`,
    orders: `${ROOTS.DASHBOARD}/orders`,
    outstanding: `${ROOTS.DASHBOARD}/outstanding`,
    dashboard: `${ROOTS.DASHBOARD}/user`,
    products: `${ROOTS.DASHBOARD}/products`,
    group: {
      root: `${ROOTS.DASHBOARD}/group`,
      five: `${ROOTS.DASHBOARD}/group/five`,
      six: `${ROOTS.DASHBOARD}/group/six`,
    },
  },
};
